
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Eye, History, Trash2 } from "lucide-react";

interface RecommendationsTabProps {
  recommendations: any[];
  getStatusColor: (status: string) => string;
  onStatusChange: (recommendation: any) => void;
  onHistoryView: (recommendationId: string) => void;
  onDelete: (recommendation: any) => void;
}

export const RecommendationsTab = ({
  recommendations,
  getStatusColor,
  onStatusChange,
  onHistoryView,
  onDelete,
}: RecommendationsTabProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Tarih</TableHead>
          <TableHead>İsim</TableHead>
          <TableHead>Email</TableHead>
          <TableHead>Telefon</TableHead>
          <TableHead>Alan</TableHead>
          <TableHead>Sınıf</TableHead>
          <TableHead>Durum</TableHead>
          <TableHead>İşlemler</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {recommendations.map((recommendation) => (
          <TableRow key={recommendation.id}>
            <TableCell>{new Date(recommendation.created_at).toLocaleDateString('tr-TR')}</TableCell>
            <TableCell>{recommendation.name_surname}</TableCell>
            <TableCell>{recommendation.email}</TableCell>
            <TableCell>{recommendation.phone}</TableCell>
            <TableCell>{recommendation.study_field}</TableCell>
            <TableCell>{recommendation.current_grade}</TableCell>
            <TableCell>
              <span className={`px-2 py-1 rounded-full text-sm ${getStatusColor(recommendation.status)}`}>
                {recommendation.status}
              </span>
            </TableCell>
            <TableCell>
              <div className="flex gap-2">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    onStatusChange(recommendation);
                  }}
                >
                  <Eye className="h-4 w-4" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    onHistoryView(recommendation.id);
                  }}
                >
                  <History className="h-4 w-4" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(recommendation);
                  }}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
